import { useState, useEffect } from 'react';
import { Car } from '@upstart/harmony/lib/legos/carTypes';
import { Dealer, DealerId } from '@upstart/harmony/lib/legos/dealerTypes';
import DealerService from '../../services/DealerService';

interface Props {
  car?: Car;
  dealer?: Dealer;
}

const useFetchDealOwner = (props: Props) => {
  const [dealOwner, setDealOwner] = useState(props.dealer);
  const [fetchingDealOwner, setFetchingDealOwner] = useState(false);

  const carDealerId = props.car?.dealer_id;
  useEffect(() => {
    // if props.car did not come from dealer, it means it came from a partner store
    // so we go fetch the partner store
    if (carDealerId && carDealerId !== props.dealer?.id) {
      const fetchDealer = async (dealerId: DealerId) => {
        setFetchingDealOwner(true);
        try {
          setDealOwner(await DealerService.getDealer(dealerId));
        } catch (ignore) {} // eslint-disable-line no-empty
        setFetchingDealOwner(false);
      };
      fetchDealer(carDealerId);
    } else if (carDealerId && carDealerId === props.dealer?.id) {
      setDealOwner(props.dealer);
    }
  }, [carDealerId, props.dealer]);

  return { dealOwner, fetchingDealOwner };
};

export default useFetchDealOwner;
